module.exports = __webpack_public_path__ + "img/q4.cf1a5f03.svg";